var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Canvas",
    transform: "translate(3419 851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__noun_1041249_cc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share_svg__share_svg__path0_fill",
    transform: "translate(-3419 -842.724)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share_svg__share_svg__path1_fill",
    transform: "translate(-3406.01 -851)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share_svg__share_svg__path2_fill",
    transform: "translate(-3406.01 -834.854)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share_svg__share_svg__path3_fill",
    transform: "translate(-3411.96 -846.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share_svg__share_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#share_svg__share_svg__path4_fill",
    transform: "translate(-3411.86 -837.977)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "share_svg__share_svg__path0_fill",
    d: "M 3.50649 -1.93682e-07C 1.58442 -1.93682e-07 0 1.54856 0 3.42715C 0 5.30574 1.58442 6.85431 3.50649 6.85431C 5.42857 6.85431 7.01299 5.30574 7.01299 3.42715C 7.01299 1.54856 5.45455 -1.93682e-07 3.50649 -1.93682e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share_svg__share_svg__path1_fill",
    d: "M 3.50649 6.8543C 5.42857 6.8543 7.01299 5.30574 7.01299 3.42715C 7.01299 1.54857 5.42857 -4.84205e-08 3.50649 -4.84205e-08C 1.58442 -4.84205e-08 0 1.54857 0 3.42715C 0 5.30574 1.55844 6.8543 3.50649 6.8543ZM 1.03896 3.42715C 1.03896 2.10706 2.15584 1.01545 3.50649 1.01545C 4.85714 1.01545 5.97403 2.10706 5.97403 3.42715C 5.97403 4.74724 4.85714 5.83885 3.50649 5.83885C 2.15584 5.83885 1.03896 4.74724 1.03896 3.42715Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share_svg__share_svg__path2_fill",
    d: "M 3.50649 7.74729e-07C 1.58442 7.74729e-07 0 1.54857 0 3.42715C 0 5.30574 1.55844 6.85431 3.50649 6.85431C 5.45455 6.85431 7.01299 5.30574 7.01299 3.42715C 7.01299 1.54857 5.42857 7.74729e-07 3.50649 7.74729e-07ZM 5.97403 3.42715C 5.97403 4.74724 4.85714 5.83885 3.50649 5.83885C 2.15584 5.83885 1.03896 4.74724 1.03896 3.42715C 1.03896 2.10706 2.15584 1.01545 3.50649 1.01545C 4.85714 1.01545 5.97403 2.10706 5.97403 3.42715Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share_svg__share_svg__path3_fill",
    d: "M 0.493506 5.33113L 6.41558 0.888521L 6.33766 0.786976C 6.18182 0.583885 6.05195 0.380795 5.94805 0.152318L 5.87013 0L -3.96332e-07 4.41722L 0.0779225 4.51876C 0.233767 4.74724 0.337662 4.95033 0.441558 5.17881L 0.493506 5.33113Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share_svg__share_svg__path4_fill",
    d: "M 6.18182 4.34106L 0.441559 0L 0.38961 0.152317C 0.285714 0.380794 0.181818 0.609271 0.0519482 0.837748L 0 0.939294L 5.71429 5.22958L 5.79221 5.07726C 5.8961 4.84879 6 4.62031 6.15584 4.41722L 6.18182 4.34106Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.147b342e7694299d0e4707d79c36b2fd.svg";
export { ForwardRef as ReactComponent };